import { typedQueryClient, useTypedMutation } from "hooks";
import { AgreementsDashboardQueryKeys } from "modules/AgreementsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { CreateEditAgreementPayload } from "modules/AgreementsDashboard/hooks/useCreateAgreementMutation";

export const useUpdateAgreementMutation = () =>
  useTypedMutation<CreateEditAgreementPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/check_in/agreement/update", payload);
    },
    onSuccess: payload => {
      const agreements = typedQueryClient.getQueryData(AgreementsDashboardQueryKeys.list);
      if (!agreements) return;

      const agreementIdx = agreements.findIndex(agreement => agreement.id === payload.id);
      if (agreementIdx === -1) return;

      typedQueryClient.setQueryData(
        AgreementsDashboardQueryKeys.list,
        agreements.with(agreementIdx, { ...agreements[agreementIdx], ...payload, updated_on: toISOString(new Date()) })
      );
    }
  });
